import { useEffect } from "react";
import { Link } from "react-router-dom";
import { useConsent, setConsent, loadAnalytics } from "@/lib/consent";

export const CookieBanner = () => {
  const consent = useConsent();
  useEffect(() => {
    if (consent === "accepted") loadAnalytics();
  }, [consent]);
  if (consent) return null;
  return (
    <div role="dialog" aria-label="Cookie preferences" data-testid="cookie-banner" className="fade-up fixed inset-x-3 bottom-3 z-[60] mx-auto max-w-3xl rounded-2xl border border-slate-200 bg-white p-5 shadow-xl sm:inset-x-6">
      <p className="text-sm text-slate-700">
        We use essential cookies to keep you signed in and secure. With your permission we also use analytics cookies to understand how the site is used. See our <Link to="/cookies" className="font-semibold text-[#1F8A8B] underline">cookie policy</Link>.
      </p>
      <div className="mt-4 flex flex-col gap-2 sm:flex-row sm:justify-end">
        <button data-testid="cookie-reject-button" onClick={() => setConsent("rejected")} className="btn-ghost btn-sm">Essential only</button>
        <button data-testid="cookie-accept-button" onClick={() => setConsent("accepted")} className="btn-teal btn-sm">Accept analytics</button>
      </div>
    </div>
  );
};
